module.exports = __webpack_public_path__ + "img/logo_am_white.cd494cd.png";